export function formatPageMetadataEvalCommentAuthor(createdBy: string): string {
  const trimmed = createdBy.trim()
  const at = trimmed.indexOf('@')
  if (at > 0) return trimmed.slice(0, at)
  return trimmed
}

export function formatPageMetadataEvalCommentTimestamp(
  createdAt: string
): string | undefined {
  const date = new Date(createdAt)
  if (Number.isNaN(date.getTime())) return undefined
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

export function formatPageMetadataEvalCommentByline(
  createdBy: string,
  createdAt: string
): string | undefined {
  const author = formatPageMetadataEvalCommentAuthor(createdBy)
  const timestamp = formatPageMetadataEvalCommentTimestamp(createdAt)
  if (author !== '' && timestamp !== undefined)
    return `${author} · ${timestamp}`
  if (author !== '') return author
  return timestamp
}
